/**
 * The entitlements specific to the application which are fetched from the backend depending on the roles of an user,
 */
export enum Entitlements {
  LIO_VR_TA_ANL = 'LIO_VR_TA_ANL',
  LIO_VR_TE_ANL = 'LIO_VR_TE_ANL',
  LIO_VR_TA_AUF = 'LIO_VR_TA_AUF',
  LIO_VR_TE_AUF = 'LIO_VR_TE_AUF',
  LIO_REQ_DEAL_INFO = 'LIO_REQ_DEAL_INFO',
  LIO_REQ_REPORT_VRB = 'LIO_REQ_REPORT_VRB',
  LIO_VR_ON_ANL = 'LIO_VR_ON_ANL',
  LIO_VR_ON_AUF = 'LIO_VR_ON_AUF',
  LIO_VR_TN_ANL = 'LIO_VR_TN_ANL',
  LIO_VR_TN_AUF = 'LIO_VR_TN_AUF',
  LIO_VR_SN_ANL = 'LIO_VR_SN_ANL',
  LIO_VR_SN_AUF = 'LIO_VR_SN_AUF',
  LIO_VR_REFI = 'LIO_VR_REFI',
  LIO_DZ_TA_ANL = 'LIO_DZ_TA_ANL',
  LIO_DZ_TA_AUF = 'LIO_DZ_TA_AUF',
  LIO_DZ_TE_ANL = 'LIO_DZ_TE_ANL',
  LIO_DZ_TE_AUF = 'LIO_DZ_TE_AUF',
  LIO_DZ_ON_ANL = 'LIO_DZ_ON_ANL',
  LIO_DZ_ON_AUF = 'LIO_DZ_ON_AUF',
  LIO_DZ_TN_ANL = 'LIO_DZ_TN_ANL',
  LIO_DZ_TN_AUF = 'LIO_DZ_TN_AUF',
  LIO_DZ_SN_ANL = 'LIO_DZ_SN_ANL',
  LIO_DZ_SN_AUF = 'LIO_DZ_SN_AUF',
  LIO_DZ_REFI = 'LIO_DZ_REFI',
  LIO_REQ_LIMIT = 'LIO_REQ_LIMIT',
  LIO_REQ_REPORT_DZ = 'LIO_REQ_REPORT_DZ',
  LIO_DEAL_STORNO = 'LIO_DEAL_STORNO',
  LIO_ADM_KD_KG = 'LIO_ADM_KD_KG',
  LIO_ADM_KD_KG_RO = 'LIO_ADM_KD_KG_RO',
  LIO_ADM_KD_RC = 'LIO_ADM_KD_RC',
  LIO_ADM_MARGIN = 'LIO_ADM_MARGIN',
  LIO_ADM_BETRAG = 'LIO_ADM_BETRAG',
  LIO_ADM_ZINSG = 'LIO_ADM_ZINSG',
  LIO_MARGEN = 'LIO_MARGEN',
  LIO_LAUFZEITEN = 'LIO_LAUFZEITEN',
  LIO_ADM_KURSLISTEN = 'LIO_ADM_KURSLISTEN',
  LIO_SYS_TRADE_STOP = 'LIO_SYS_TRADE_STOP',
  LIO_SYS_TRADE_TIME = 'LIO_SYS_TRADE_TIME',
  LIO_ADM_EMAIL = 'LIO_ADM_EMAIL',
  LIO_DEAL_ADMIN = 'LIO_DEAL_ADMIN',
  LIO_ADM_MDS_RO = 'LIO_ADM_MDS_RO',
  LIO_ADM_MDS_VERBINDUNG = 'LIO_ADM_MDS_VERBINDUNG',
  LIO_ADM_MDS_ABOS = 'LIO_ADM_MDS_ABOS',
  LIO_ADM_FEIERTAGE = 'LIO_ADM_FEIERTAGE',
  LIO_LAUFZEITEN_RO = 'LIO_LAUFZEITEN_RO',
  LIO_ADM_FUS = 'LIO_ADM_FUS',
  LIO_ADM_TRIGGER = 'LIO_ADM_TRIGGER',
  LIO_ADM_ZINSG_RO = 'LIO_ADM_ZINSG_RO',
  LIO_ADM_MDS = 'LIO_ADM_MDS',
  LIO_ADM_CMS = 'LIO_ADM_CMS',
  LIO_MARGEN_RO = 'LIO_MARGEN_RO',
  LIO_REPORT_ADMIN = 'LIO_REPORT_ADMIN',
  LIO_TRG_LIMIT_IMPORT = 'LIO_TRG_LIMIT_IMPORT',
  LIO_TRG_VORTAGESAUSWERTUNG_IMPORT = 'LIO_TRG_VORTAGESAUSWERTUNG_IMPORT',
  LIO_TRG_NACHVERZINSUNG = 'LIO_TRG_NACHVERZINSUNG',
  LIO_TRG_ARCHIVIERUNG = 'LIO_TRG_ARCHIVIERUNG',

  // corporates
  LIO_FK_REQ_DEAL_INFO = 'LIO_FK_REQ_DEAL_INFO',
  LIO_FK_REQ_REPORT_DZ = 'LIO_FK_REQ_REPORT_DZ',
  LIO_FK_REQ_REPORT_VRB = 'LIO_FK_REQ_REPORT_VRB',
  LIO_FK_VR_ON_ANL = 'LIO_FK_VR_ON_ANL',
  LIO_FK_VR_SN_ANL = 'LIO_FK_VR_SN_ANL',
  LIO_FK_VR_TA_ANL = 'LIO_FK_VR_TA_ANL',
  LIO_FK_VR_TE_ANL = 'LIO_FK_VR_TE_ANL',
  LIO_FK_VR_TN_ANL = 'LIO_FK_VR_TN_ANL',
  LIO_FK_DZ_ON_ANL = 'LIO_FK_DZ_ON_ANL',
  LIO_FK_DZ_SN_ANL = 'LIO_FK_DZ_SN_ANL',
  LIO_FK_DZ_TA_ANL = 'LIO_FK_DZ_TA_ANL',
  LIO_FK_DZ_TE_ANL = 'LIO_FK_DZ_TE_ANL',
  LIO_FK_DZ_TN_ANL = 'LIO_FK_DZ_TN_ANL',
  LIO_FK_SYS_TRADE_TIME = 'LIO_FK_SYS_TRADE_TIME',
  LIO_FK_SYS_TRADE_STOP = 'LIO_FK_SYS_TRADE_STOP',
  LIO_FK_ADM_BETRAG = 'LIO_FK_ADM_BETRAG',
  LIO_FK_ADM_CMS = 'LIO_FK_ADM_CMS',
  LIO_FK_ADM_FEIERTAGE = 'LIO_FK_ADM_FEIERTAGE',
  LIO_FK_ADM_KD_KG = 'LIO_FK_ADM_KD_KG',
  LIO_FK_ADM_KD_RC = 'LIO_FK_ADM_KD_RC',
  LIO_FK_ADM_ZINSG = 'LIO_FK_ADM_ZINSG',
  LIO_FK_ADM_MDS = 'LIO_FK_ADM_MDS',
  LIO_FK_ADM_EMAIL = 'LIO_FK_ADM_EMAIL',
  LIO_FK_ADM_MARGIN = 'LIO_FK_ADM_MARGIN',
  LIO_FK_DEAL_STORNO = 'LIO_FK_DEAL_STORNO',
  LIO_FK_LAUFZEITEN = 'LIO_FK_LAUFZEITEN',
  LIO_FK_LAUFZEITEN_RO = 'LIO_FK_LAUFZEITEN_RO',
  LIO_FK_MARGEN = 'LIO_FK_MARGEN',
  LIO_FK_MARGEN_RO = 'LIO_FK_MARGEN_RO',
  LIO_FK_DZ_LIMIT_ADM = 'LIO_FK_DZ_LIMIT_ADM',
  LIO_FK_DZ_LIMIT_RO = 'LIO_FK_DZ_LIMIT_RO',
  LIO_FK_DEAL_ADMIN = 'LIO_FK_DEAL_ADMIN',
  LIO_FK_TRG_NACHVERZINSUNG = 'LIO_FK_TRG_NACHVERZINSUNG'
}
